import * as _ from 'lodash';

export class StudentPreviewModalCtrl {
  static $inject = ['StudentSet', 'filter', 'columnKeys', 'description', 'SDCStore', '$mdDialog'];

  public filteredStudents;
  public humanColumnNames;
  public sortType;
  public sortReverse;
  public table;

  constructor(
    private StudentSet,
    private filter,
    private columnKeys,
    public description,
    private SDCStore,
    private $mdDialog,
  ) {
    // onInit populate modal
    this.sortType = 'studentName';
    this.sortReverse = false;
    this.filteredStudents = this.getFilteredStudents(this.filter);
    this.humanColumnNames = this.getHumanReadableColumns(this.columnKeys);
    this.table = this.buildPreviewTable();
  }

  /**
   * @param filter an SDC filter object, if null fn() will fallback & return filteredFlattenedStudents from SDCStore
   * @returns an array of modified students, NOT IStudent form
   */
  getFilteredStudents(filter: any): any[] {
    const filteredStudents = filter
      ? this.SDCStore.getFilteredFlattenedStudents(filter)
      : this.SDCStore.getFilteredFlattenedStudents();
    return filteredStudents;
  }

  /**
   * @param columnKeys an array of sorterColumn keys
   * @returns an array of object containing the sorterColumn name: humanReadable column name
   */
  getHumanReadableColumns(columnKeys: string[]): any[] {
    const keysPlusDefaults = _.uniq(['studentId', 'studentName', ...columnKeys]);
    const columnDefinitions = this.StudentSet.getColumnDefs(keysPlusDefaults);
    const humanColumnNames = _.map(columnDefinitions, (col: any, index: number) => {
      const obj = { path: null, human: null };
      obj.path = keysPlusDefaults[index];
      obj.human = col.headerName;
      return obj;
    });
    return humanColumnNames;
  }

  buildPreviewTable() {
    return _.reduce(
      this.filteredStudents,
      (table, student) => {
        const row = {};
        _.each(this.humanColumnNames, (col: any) => {
          let cellValue = student[col.path];
          if (_.isArray(cellValue)) cellValue = cellValue.join(', ');
          if (col.path === 'hasPotentialCreditIssuesOnCurrProgram') {
            const { coursesPotentialCreditIssues } = student;
            row[col.path] = this.renderCellVal(col.path, cellValue, { coursesPotentialCreditIssues });
          } else {
            row[col.path] = this.renderCellVal(col.path, cellValue);
          }
        });
        table.push(row);
        return table;
      },
      [],
    );
  }

  closePreview(): void {
    this.$mdDialog.hide();
  }

  // Add more rules down the road if any bool value needs to be reformed into a more readable name (JChu)
  // To get some info on cellVal datatype, please refer to sorter-column-data-type.constant.ts
  renderCellVal(key: string, cellVal: any, args?: any) {
    switch (key) {
      case 'hasPotentialCreditIssuesOnCurrProgram':
        const { coursesPotentialCreditIssues } = args;
        return cellVal === true && coursesPotentialCreditIssues
          ? _.map(coursesPotentialCreditIssues, 'courseName').join()
          : '';
      case 'schoolVerifiedSafetyNetEligibility':
      case 'isSafetyNetEligible':
        return cellVal === true ? 'Eligible' : cellVal === false ? 'Not Eligible' : '-';
      case 'iep':
        return cellVal === true ? 'Yes' : cellVal === false ? 'No' : '-';
      case 'potentiallyEligibleForSafetyNet':
        return !cellVal ? '-' : cellVal;
      default:
        return cellVal;
    }
  }
}

angular.module('nv.shared.modals').controller('StudentPreviewModalCtrl', StudentPreviewModalCtrl);
